import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialShopifyPosReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const shopifyPosSlice = createSlice({
    name: "ShopifyPos",
    initialState: { ...initialShopifyPosReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default shopifyPosSlice;
